export default __webpack_public_path__ + "static/media/3.58d15efd.svg";